export default __webpack_public_path__ + "static/media/warehouses-dark.2bf4a615.png";